module.exports = __webpack_public_path__ + "../resources/img/ic_cancel.59086a4a.svg";